import { render, staticRenderFns } from "./CoUser.vue?vue&type=template&id=79248624&scoped=true&"
import script from "./CoUser.vue?vue&type=script&lang=ts&"
export * from "./CoUser.vue?vue&type=script&lang=ts&"
import style0 from "./CoUser.vue?vue&type=style&index=0&id=79248624&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79248624",
  null
  
)

export default component.exports